import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Card, Image, Form, Button, Modal } from 'react-bootstrap';
import TemplatelayoutOne from '../../component/preview/displaytemplatelayout/TemplatelayoutOne';
import TemplatelayoutTwo from '../../component/preview/displaytemplatelayout/TemplatelayoutTwo';
import { getItem, setItem, clearItem } from '../../config/localStorage';
import ResumeTempOne from '../../assets/image/resume_temp_1.png'
import ResumeTempTwo from '../../assets/image/resume_temp_2.png'
import ReactToPrint from 'react-to-print';
import { jwtDecode } from 'jwt-decode';
import { useLocation, useNavigate } from 'react-router-dom';
import { pythonAxiosInstance } from '../../config/ConfigInfo';
import PageLoader from '../../component/loader/PageLoader';


function ReviewResume() {

    const [reuseToken, setReuseToken] = useState('');
    const [reusePythonToken, setPythonReuseToken] = useState('');

    const getUserId = jwtDecode(getItem('token'));
    const resumeUserId = getUserId.UserID;
    const levelOfEducationInfo = getItem('levelOfEducation');
    const experienceNeedResumeTypeInfo = getItem('experienceNeedResumeType');
    const choosenTemplateTypeInfo = getItem('choosenTemplateType') ?? '1';
    const resumeBuildTypeInfo = getItem('resumeBuildType');
    const profileDetailInfo = JSON.parse(getItem('profileData'));
    const profileImageInfo = getItem('profileImage');
    const experienceDetailInfo = JSON.parse(getItem('experienceData'));
    const educationDetailInfo = JSON.parse(getItem('educationData'));
    const SkillItemInfo = getItem('ratingItem'); // Skill list Item
    const SkillItemWithRating = JSON.parse(getItem('rating')); // Skill list Item with rating
    const jobTitleInfo = getItem('jobTitle')?.trim();
    const summaryItemInfo = getItem('summaryItem') !== null ? getItem('summaryItem') : '';
    const personalDetailsInfo = getItem('personalDetailsData') !== null ? JSON.parse(getItem('personalDetailsData')) : '';
    const webPortProfileInfo = getItem('webPortProfileData') !== null ? JSON.parse(getItem('webPortProfileData')) : '';
    const accomplishmentsInfo = getItem('accomplishmentsData') !== null ? getItem('accomplishmentsData') : '';
    const affiliationsInfo = getItem('affiliationsData') !== null ? getItem('affiliationsData') : '';
    const additionalInfromationInfo = getItem('additionalInformationData') !== null ? getItem('additionalInformationData') : '';
    const languagesDataInfo = getItem('languagesData') !== null ? JSON.parse(getItem('languagesData')) : '';
    const certificationsDataInfo = getItem('certificationsData') ? JSON.parse(getItem('certificationsData')) : '';
    const interestsDataInfo = getItem('interestsData') !== null ? JSON.parse(getItem('interestsData')) : '';
    const hobbiesDataInfo = getItem('hobbiesData') !== null ? JSON.parse(getItem('hobbiesData')) : '';

    const [isLoading, setIsLoading] = useState(false);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setReuseToken(getItem('token'));
        setPythonReuseToken(getItem('authToken'))
    }, [reuseToken, reusePythonToken])

    useEffect(() => {
        if (location.state === null || location.state.setReviewResume === false || resumeBuildTypeInfo === null) {
            navigate('/resume-builder');
        }
    }, []);

    const backFinalizePage = () => {
        navigate('/finalize', { state: { moveFinalizePage: true } });
    }


    const colors = [
        '34ad41',
        '2c5f70',
        '85caa6',
        'a394ff',
        '2973fc',
        'f9b797',
        '1b1e21',
        '838689',
        'f97968',
        '' // blank to reset template color 
    ];

    const defaultTempType = '1';
    const chossenTempType = getItem('choosenTemplateType');
    const [tempImage, setTempImage] = useState(chossenTempType ?? defaultTempType);

    const [choosenTemplate, setChoosenTemplate] = useState(tempImage);
    const [selectedColor, setSelectedColor] = useState(null);

    const ChangeTemplateOption = (e) => {
        const selectedValue = document.querySelector('input[name="template-option"]:checked').value;
        setItem('choosenTemplateType', selectedValue);
        setTempImage(selectedValue);
        setChoosenTemplate(selectedValue)
    }

    const handleColorDisplay = (colorValue) => {
        setSelectedColor(colorValue);
    };

    const printPdf = () => {
        let pdfData = document.getElementById('templatePdf');
        return pdfData;
    }


    const sendUserDataDb = async () => {
        const payload = {
            resumeUserId,
            levelOfEducationInfo,
            experienceNeedResumeTypeInfo,
            choosenTemplateTypeInfo,
            resumeBuildTypeInfo,
            profileDetailInfo,
            profileImageInfo,
            experienceDetailInfo,
            educationDetailInfo,
            SkillItemInfo,
            SkillItemWithRating,
            jobTitleInfo,
            summaryItemInfo,
            personalDetailsInfo,
            webPortProfileInfo,
            accomplishmentsInfo,
            affiliationsInfo,
            additionalInfromationInfo,
            languagesDataInfo,
            certificationsDataInfo,
            interestsDataInfo,
            hobbiesDataInfo
        };

        setIsLoading(true)

        try {
            const response = await pythonAxiosInstance.post('save-all-data/', payload);
            if (response?.data?.status === 'success') {
                setIsLoading(false)
                clearItem();
                setItem('token', reuseToken);
                setItem('authToken', reusePythonToken);
                navigate('/thank-you', { state: { moveThankYouPage: true } });
            }
        } catch (error) {
            setIsLoading(false)
        }

    }

    return (
        <>
            <section className='main-section padding-top-bottom final-review-resume-main-section'>
                <Container>
                    <Row>
                        <Col md={12}>

                            <div className='resume-review-loader-section'>
                                <PageLoader isLoading={isLoading} />
                            </div>

                            <Card className='final-review-resume-card-option shadow border-0'>
                                < Card.Body className='final-review-resume-main'>
                                    <Row>
                                        <Col md={12} className='final-review-resume-one-text-outer'>
                                            <div className='final-review-resume-one-text'>
                                                <h2>Review Your Resume</h2>
                                                <p>Review and make any final change your resume. then save & print yourself a copy and apply for job.</p>
                                            </div>
                                            {
                                                location?.state?.hideBackButton === true ?
                                                    <div className="alert alert-info" role="alert">
                                                        <strong>Note: </strong>
                                                        Awesome news! We've jazzed up your uploaded PDF and given it a fresh new look.
                                                        It matches over 90% of your updated resume below. If you’re happy with the results,
                                                        go ahead and download your shiny new resume PDF.
                                                        If not, no worries – you can always create a new resume that’s perfect for you!
                                                    </div>
                                                    : ''
                                            }
                                        </Col>
                                        <Col md={8}>
                                            <Col className='outer-temp-preview'>
                                                {/* <div id='templatePdf' ref={targetRef}> */}
                                                <div id='templatePdf'>
                                                    {
                                                        tempImage === '1' ?
                                                            <TemplatelayoutOne colorDisplay={selectedColor} /> :
                                                            <TemplatelayoutTwo colorDisplay={selectedColor} />
                                                    }
                                                </div>
                                            </Col>
                                            {
                                                location?.state?.hideBackButton === true ? '' :
                                                    <Button className='my-previous-btn float-start mt-3 mb-3' onClick={backFinalizePage}>Back</Button>
                                            }
                                        </Col>
                                        <Col md={4}>
                                            <Col className='fix-the-section-in-scroll'>

                                                <div className="accordion" id="accordion-color-temp-section">
                                                    <div className="accordion-item">
                                                        <h2 className="accordion-header" id="headingOne">
                                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                                Template & Color
                                                            </button>
                                                        </h2>
                                                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                            <div className="accordion-body">
                                                                <Form>
                                                                    <Row className='temp-color-section'>
                                                                        {
                                                                            colors.map((color, index) => (
                                                                                <div key={index}>
                                                                                    <input
                                                                                        type="radio"
                                                                                        className="btn-check"
                                                                                        name="finalChoosenColor"
                                                                                        value={color}
                                                                                        defaultChecked={selectedColor === color}
                                                                                    />
                                                                                    <label className="btn color-item" style={{ backgroundColor: "#" + color }} onClick={() => handleColorDisplay(color)}></label>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </Row>
                                                                </Form>

                                                                <Row className='template-section'>
                                                                    <Col md={12}>
                                                                        <Form className='choose-template-form'>
                                                                            <div className="image_radio_button_control">
                                                                                <label className={`radio-button-label ${choosenTemplate === '1' ? 'show' : ''}`} >
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="template-option"
                                                                                        defaultValue="1"
                                                                                        onClick={ChangeTemplateOption}
                                                                                        defaultChecked={tempImage === "1"}
                                                                                    />
                                                                                    <Image src={ResumeTempOne} alt="template-image" className='w-100' />
                                                                                </label>
                                                                                <label className={`radio-button-label ${choosenTemplate === '2' ? 'show' : ''}`} >
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="template-option"
                                                                                        defaultValue="2"
                                                                                        onClick={ChangeTemplateOption}
                                                                                        defaultChecked={tempImage === "2"}
                                                                                    />
                                                                                    <Image src={ResumeTempTwo} alt="template-image" className='w-100' />
                                                                                </label>
                                                                            </div>
                                                                        </Form>
                                                                    </Col>
                                                                </Row>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <Row className='dp-btn-section mt-4'>

                                                    <ReactToPrint
                                                        trigger={() =>
                                                            <div className="col ">
                                                                <div className="card download-btn-sec">
                                                                    <p className="">Save & Print</p>
                                                                    <i className="fa-solid fa-print d-none"></i>
                                                                </div>
                                                            </div>
                                                        }
                                                        content={printPdf}
                                                    />

                                                    <div className="col d-none">
                                                        <div className="card download-btn-sec">
                                                            <p className="">Email</p>
                                                            <i className="fa-regular fa-envelope"></i>
                                                        </div>

                                                    </div>
                                                </Row>

                                                <Row className='finish-btn-section mt-3'>
                                                    <Col md={12}>
                                                        <Button className='btn button-green btn-primary w-100' onClick={handleShow}>Continue</Button>
                                                    </Col>
                                                </Row>

                                            </Col>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <Modal show={show} onHide={handleClose} animation={false} >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body className='text-center pt-4 pb-4 pl-2 pr-4'>
                        <h5>Are you sure?</h5>
                        <p className='mb-0'>Please save & print your resume otherwise your work will be lost. </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <ReactToPrint
                            trigger={() =>
                                <Button className="btn button-green">
                                    Save & Print
                                </Button>
                            }
                            content={printPdf}
                        />
                        <Button className="btn btn-danger" onClick={sendUserDataDb}>
                            Finish
                        </Button>
                    </Modal.Footer>
                </Modal>

            </section>
        </>
    )
}


export default ReviewResume
